"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifferenceInHours = void 0;
const getDifferenceInMinutes_js_1 = require("./getDifferenceInMinutes.js");
/**
 * Get the number of hour(s) between the given dates.
 */
const getDifferenceInHours = (dateLeft, dateRight) => {
    const differenceInMinutes = (0, getDifferenceInMinutes_js_1.getDifferenceInMinutes)(dateLeft, dateRight);
    return differenceInMinutes / 60;
};
exports.getDifferenceInHours = getDifferenceInHours;
//# sourceMappingURL=getDifferenceInHours.js.map